import { IAutoCompleteFunc } from '../interfaces';
import { AutoCompleteOperator } from '../enums';
import { AutoCompleteOperatorOptions } from '../interfaces/options';

export class AutoCompleteUtil {
	static fn: IAutoCompleteFunc = {
		[AutoCompleteOperator.IndexOfCaseInSensitive]: (
			value: string,
			input: string,
			factor: number = 1
		): number => {
			let index: number,
				points: number = 1;
			value = value.toLocaleLowerCase();
			input = input.toLocaleLowerCase();
			if ((index = value.indexOf(input)) >= 0) {
				points = index / value.length;
			}
			return points / factor;
		},
		[AutoCompleteOperator.IndexOfCaseSensitive]: (
			value: string,
			input: string,
			factor: number = 1
		): number => {
			let index: number,
				points: number = 1;
			if ((index = value.indexOf(input)) >= 0) {
				points = index / value.length;
			}
			return points / factor;
		},
		[AutoCompleteOperator.Length]: (value: string, input: string, factor: number = 1): number => {
			let dif: number,
				points: number = 1;
			if ((dif = input.length / value.length) <= 1) {
				points = 1 - dif;
			}
			return points / factor;
		}
	};
	public static isAutoCompleteOperator(value: any): value is AutoCompleteOperator {
		return (
			(typeof value === 'string' || typeof value === 'number') &&
			AutoCompleteOperator[value] !== undefined
		);
	}
	public static isAutoCompleteOperatorOptions(value: any): value is AutoCompleteOperatorOptions {
		return (
			(<AutoCompleteOperatorOptions>value).factor !== undefined &&
			(<AutoCompleteOperatorOptions>value).operator !== undefined
		);
	}
}
